// This file is generated by pnpm icons:generate. Do not edit.

import {ArrowBoxRight_Stroke2_Corner3_Rounded as CanonicalArrowBoxRight_Stroke2_Corner3_Rounded} from './Arrow'

/** @deprecated Import ArrowBoxRight_Stroke2_Corner3_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowBoxRight_Stroke2_Corner3_Rounded =
  CanonicalArrowBoxRight_Stroke2_Corner3_Rounded
